import { combineReducers, createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import * as moment from 'moment';

import calendarReducer from './reducers/buytickets.reducer';
import { IBuyTicketsState, IBuyTicketsSettings, defaultCalendarSettings } from '../classes/buytickets';
import { ICalendarAppBaseText } from '../classes/buytickets-text';
import { IEvent } from '../classes/event';

import calendarSettingsReducer from './reducers/buytickets-settings.reducer';
import { getEventsFromApi, getShowInfoFromApi } from './actions/buytickets-api.actions';
import calendarTextReducer from './reducers/buytickets-text.reducer';
import { GetFilterFromQuery, AddFilterToQuery } from '../helpers/filter-by-query';
declare const lastDate: string;
const lastDateMoment = moment(lastDate);

export interface IBuyTicketsAppState {
    calendar: IBuyTicketsState<IEvent>;
    calendarSettings: IBuyTicketsSettings;
    calendarText: ICalendarAppBaseText;
}

const appReducer = combineReducers({
    calendar: calendarReducer,
    calendarSettings: calendarSettingsReducer,
    calendarText: calendarTextReducer,
});

// Calculate the months that are valid on the calendar.
let monthsOnCalendar: moment.Moment[] = [];

for (let i = moment().clone().startOf("month"); i.isSameOrBefore(lastDateMoment.endOf("month")); i.add(1, "month")) {
    monthsOnCalendar.push(i.clone());
}

let calendarSettings = {
    ...defaultCalendarSettings,
    monthsOnCalendar: monthsOnCalendar
};

const appStore = createStore(appReducer, {
    calendarSettings: calendarSettings
}, applyMiddleware(thunk));


if (window.location.hash.length > 1) {
    GetFilterFromQuery(window.location.hash, appStore);
}

// redux-thunk messes with redux typings.
appStore.dispatch(getEventsFromApi() as any);
appStore.dispatch(getShowInfoFromApi() as any);
let prevState = appStore.getState();

appStore.subscribe(() => {
    const currState = appStore.getState();

    const apiUpdate = !prevState.calendar.startDate.isSame(currState.calendar.startDate) || !prevState.calendar.endDate.isSame(currState.calendar.endDate);

    AddFilterToQuery(currState.calendar);

    // If the event references are completely different, re-calculate them.
    if (apiUpdate || (currState.calendar.updating && prevState.calendar.events !== currState.calendar.events)) {
        prevState = appStore.getState();

        appStore.dispatch(getEventsFromApi() as any);
    }
});

export { appStore };